import { CardAction, ChickletHoverActions } from '../../constants/BehaviorTypes';
import FlywheelCompanyCardAction from '../../behaviors/flywheel/company/FlywheelCompanyCardAction';
import { getFlywheelCompanyChickletHoverActions } from '../../behaviors/flywheel/company/getFlywheelCompanyChickletHoverActions';
export const Company = {
  [CardAction]: () => FlywheelCompanyCardAction,
  [ChickletHoverActions]: getFlywheelCompanyChickletHoverActions
};